export default __webpack_public_path__ + "locales/pt/DeleteThirdPartyDialog.json?hash=9e2e7baf4f7fd6cc4bf514183669df0e";